import { render, staticRenderFns } from "./quote-form.vue?vue&type=template&id=24714f10&"
import script from "./quote-form.vue?vue&type=script&lang=ts&"
export * from "./quote-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports